"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreadcrumbs = exports.useBreadcrumb = void 0;
const react_1 = require("react");
const Breadcrumb_context_1 = require("./Breadcrumb.context");
/**
 * For manually setting a single breadcrumb
 * @param newBreadcrumb
 */
const useBreadcrumb = (newBreadcrumb) => {
    const { registerBreadcrumb, updateBreadcrumb, removeBreadcrumb } = (0, react_1.useContext)(Breadcrumb_context_1.BreadcrumbContext);
    const [breadcrumb, setBreadcrumb] = (0, react_1.useState)(newBreadcrumb);
    // register the breadcrumb and get the index of the breadcrumb on mount
    const index = (0, react_1.useMemo)(() => registerBreadcrumb(breadcrumb), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // hanlde updates to the breadcrumb
    (0, react_1.useEffect)(() => {
        if (breadcrumb) {
            updateBreadcrumb(index, breadcrumb);
        }
        return () => {
            // remove breadcrumb on unmount
            removeBreadcrumb(index);
        };
    }, [
        breadcrumb,
        index,
        registerBreadcrumb,
        removeBreadcrumb,
        updateBreadcrumb
    ]);
    return { breadcrumb, setBreadcrumb };
};
exports.useBreadcrumb = useBreadcrumb;
/**
 * For manually setting multiple breadcrumbs
 * @param newBreadcrumbs
 */
const useBreadcrumbs = (newBreadcrumbs) => {
    const { registerBreadcrumb, updateBreadcrumb, removeBreadcrumb } = (0, react_1.useContext)(Breadcrumb_context_1.BreadcrumbContext);
    const [breadcrumbs, setBreadcrumbs] = (0, react_1.useState)(newBreadcrumbs || []);
    const indexArray = (0, react_1.useMemo)(() => breadcrumbs.map(breadcrumb => registerBreadcrumb(breadcrumb)), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, react_1.useEffect)(() => {
        if (breadcrumbs) {
            breadcrumbs.forEach((breadcrumb, index) => {
                updateBreadcrumb(indexArray[index], breadcrumb);
            });
        }
        return () => {
            // remove breadcrumb on unmount
            for (let i = indexArray.length - 1; i >= 0; i--) {
                removeBreadcrumb(indexArray[i]);
            }
        };
    }, [
        breadcrumbs,
        indexArray,
        registerBreadcrumb,
        removeBreadcrumb,
        updateBreadcrumb
    ]);
    return { breadcrumbs, setBreadcrumbs };
};
exports.useBreadcrumbs = useBreadcrumbs;
//# sourceMappingURL=Breadcrumb.hooks.js.map